import { useState, useCallback } from "react"

export const useToggleState = (initialState = false) => {
  const [show, setShow] = useState(initialState)

  const toggle = useCallback(() => {
    setShow((prev) => !prev)
  }, [])

  const open = useCallback(() => {
    setShow(true)
  }, [])

  const close = useCallback(() => {
    setShow(false)
  }, [])

  return {
    show,
    open,
    toggle,
    close
  }
}
